"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonHorizontalList = require("@mmc/common-horizontal-list");
var _commonLibs = require("@mmc/common-libs");
var _locationPrompt = require("@mmc/location-prompt");
var _structuredData = require("@mmc/structured-data");
var _themeProvider = require("@mmc/theme-provider");
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _reactRouter = require("react-router");
var _clsx9 = _interopRequireDefault(require("clsx"));
var _reactRedux = require("react-redux");
var _tooltip = _interopRequireDefault(require("./tooltip"));
var _commonTooltip = _interopRequireDefault(require("./common-tooltip"));
var _linkItem = _interopRequireDefault(require("./link-item"));
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var _navigationHeader2 = require("./navigation-header.propTypes");
var _commonSetLocation = require("@mmc/common-set-location");
var _menuPanelMobileOffCanvas = _interopRequireDefault(require("./menu-panel-mobile-off-canvas"));
var _menuPanelRenderer = require("./menu-panel-renderer");
var _data = _interopRequireDefault(require("./data.json"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _DataUtils = new _mmcDataUtilities["default"](),
  isEmptyArray = _DataUtils.isEmptyArray,
  handleNestedProp = _DataUtils.handleNestedProp;

// @Todo - cleanup after integrating real data

var previousScrollY = 0;

/**
 * ## NavigationHeaderV2 - component
 *
 * Global Navigation Header lives across all pages.
 */
var NavigationHeaderV2 = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(NavigationHeaderV2, _Component);
  NavigationHeaderV2.resourceType = function resourceType() {
    return 'Header';
  };
  NavigationHeaderV2.childHasAsset = function childHasAsset(hasImageAsset, hasVideoAsset) {
    return !!(hasImageAsset || hasVideoAsset);
  };
  NavigationHeaderV2.isSolidBackground = function isSolidBackground(solidBackground, hasAsset, sectionLinks) {
    if (typeof solidBackground !== 'undefined') {
      if (hasAsset) {
        return false;
      }
      if (sectionLinks.length > 0) {
        return true;
      }
      return solidBackground;
    }
    return true;
  };
  NavigationHeaderV2.getScrollPosition = function getScrollPosition() {
    return typeof window !== 'undefined' ? window.pageYOffset || document.documentElement.scrollTop : 0;
  };
  NavigationHeaderV2.getScrollDirection = function getScrollDirection(scrollPosition) {
    return scrollPosition > previousScrollY ? 'down' : 'up';
  };
  NavigationHeaderV2.renderArrow = function renderArrow() {
    return /*#__PURE__*/_react["default"].createElement("img", {
      className: _navigationHeader["default"].navArrow,
      src: "data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 4.532L1.41 0 0 1.395l6 5.938 6-5.938L10.59 0z' fill='%23C8C8C8' fill-rule='evenodd'/%3E%3C/svg%3E",
      alt: "nav_arrow"
    });
  };
  NavigationHeaderV2.getAriaData = function getAriaData(domEl) {
    // is this the aria element
    var hasRole = domEl.hasAttribute('role');
    var ariaTarget = hasRole && domEl.getAttribute('role') === 'menuitem' ? domEl : domEl.querySelector('[role="menuitem"]');
    var role = ariaTarget.getAttribute('role');
    if (role !== 'menuitem') {
      return false;
    }
    var setsize = parseInt(ariaTarget.getAttribute('aria-setsize'), 10);
    var posinset = parseInt(ariaTarget.getAttribute('aria-posinset'), 10);
    var expanded = ariaTarget.getAttribute('aria-expanded') === 'true';
    var haspopup = ariaTarget.getAttribute('aria-haspopup') === 'true';
    return {
      role: role,
      expanded: expanded,
      setsize: setsize,
      posinset: posinset,
      haspopup: haspopup
    };
  };
  NavigationHeaderV2.moveLeft = function moveLeft(domEl) {
    var targetMenuItem = domEl.previousSibling;
    if (targetMenuItem !== null) {
      targetMenuItem.querySelector('button, a').focus();
    }
  };
  NavigationHeaderV2.moveRight = function moveRight(domEl) {
    var targetMenuItem = domEl.nextSibling;
    if (targetMenuItem !== null) {
      targetMenuItem.querySelector('button, a').focus();
    }
  };
  NavigationHeaderV2.getToolTipMessage = function getToolTipMessage(languages) {
    var selected = languages.filter(function (lang) {
      return lang.selected;
    });
    return selected.length > 0 ? selected[0].tooltip : '';
  };
  NavigationHeaderV2.getToolTipLanguage = function getToolTipLanguage(languages) {
    var assumedTooltipLangData = languages.length === 2 ? languages.filter(function (lang) {
      return !lang.selected;
    }) : [];
    return assumedTooltipLangData.length > 0 ? assumedTooltipLangData[0].acronym : '';
  };
  NavigationHeaderV2.getSelectedIndex = function getSelectedIndex(items) {
    return items.findIndex(function (item) {
      return item.selected === true;
    });
  };
  NavigationHeaderV2.handlePageScroll = function handlePageScroll(isDropdownOpen) {
    if (isDropdownOpen) {
      (0, _themeProvider.disableBodyScroll)();
    } else {
      (0, _themeProvider.enableBodyScroll)();
    }
  };
  NavigationHeaderV2.renderSectionLinks = function renderSectionLinks(params) {
    var _clsx;
    var sectionLinks = params.sectionLinks,
      theme = params.theme,
      overrideParentPageLabelText = params.overrideParentPageLabelText,
      secondaryNavHeading = params.secondaryNavHeading;
    return sectionLinks.length > 0 && /*#__PURE__*/_react["default"].createElement("nav", {
      className: (0, _clsx9["default"])(_navigationHeader["default"].navQuickLinksInner, _navigationHeader["default"].secondaryNav)
    }, /*#__PURE__*/_react["default"].createElement(_commonHorizontalList.NavigationHorizontalList, {
      items: sectionLinks,
      activeIndex: NavigationHeaderV2.getSelectedIndex(sectionLinks),
      theme: theme,
      classes: (0, _clsx9["default"])(_navigationHeader["default"].secondaryNavQuickLinkList, (_clsx = {}, _clsx[_navigationHeader["default"].withTitle] = secondaryNavHeading, _clsx)),
      ctaWrapperClasses: [_navigationHeader["default"].tabWrapper],
      ctaClasses: [_navigationHeader["default"].mmcRegular],
      selectName: "navigation-header__tabSelect",
      spaceBetweenArrows: true,
      arrowIsDark: true,
      showDropdownMenuIfScrollable: true,
      showSelectMenuAllBreakpoints: false,
      overviewText: overrideParentPageLabelText,
      onDropdownToggle: NavigationHeaderV2.handlePageScroll,
      secondaryNavHeading: secondaryNavHeading
    }));
  };
  NavigationHeaderV2.getHeaderSpacerHeight = function getHeaderSpacerHeight(ref) {
    return new Promise(function (resolve) {
      // new `IntersectionObserver` constructor
      var observer = new IntersectionObserver(function (entries) {
        // Loop through all `entries` returned by the observer
        // The `entry.boundingClientRect` is where all the dimensions are stored
        var bounds = entries[0].boundingClientRect;
        // Disconnect the observer to stop from running in the background
        observer.disconnect();
        resolve(bounds);
      });
      // Run the `observe` function of the `IntersectionObserver` on the element
      if (ref.current) {
        observer.observe(ref.current);
      }
    });
  };
  NavigationHeaderV2.renderBreadCrumbLink = function renderBreadCrumbLink(params) {
    var link = params.link,
      idx = params.idx,
      linksLength = params.linksLength,
      theme = params.theme;
    if (linksLength === idx + 1) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: "breadcrumb_" + idx
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _clsx9["default"])(_navigationHeader["default"].breadcrumbLast, theme.labelMedium)
      }, handleNestedProp(link, 'link.label')));
    }
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: (0, _clsx9["default"])(_navigationHeader["default"].breadCrumbLinkListItem, _navigationHeader["default"].hideMobile),
      key: "breadcrumb_" + idx
    }, this.isRTL && /*#__PURE__*/_react["default"].createElement("span", {
      className: _navigationHeader["default"].breadCrumbArrow
    }), /*#__PURE__*/_react["default"].createElement("a", {
      className: _navigationHeader["default"].breadcrumbLink,
      href: handleNestedProp(link, 'link.url')
    }, handleNestedProp(link, 'link.label')), !this.isRTL && /*#__PURE__*/_react["default"].createElement("span", {
      className: _navigationHeader["default"].breadCrumbArrow
    }));
  };
  NavigationHeaderV2.renderBreadCrumbLinkPrev = function renderBreadCrumbLinkPrev(params) {
    var link = params.link,
      theme = params.theme;
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: (0, _clsx9["default"])(_navigationHeader["default"].breadCrumbLinkListItem, _navigationHeader["default"].hideDesktop),
      key: "breadcrumb_prev"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: _navigationHeader["default"].breadcrumbLink,
      href: handleNestedProp(link, 'link.url')
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: (0, _clsx9["default"])(_navigationHeader["default"].breadCrumbLinkListItemIcon, theme.mmcIconChevronLeft)
    })));
  };
  NavigationHeaderV2.renderLanguageLink = function renderLanguageLink(language, languageSpecificPageSelection, queryString, i) {
    var setFont = function setFont(langCode) {
      if (langCode !== '') {
        return {
          fontFamily: "'MMC-Regular-" + langCode.toUpperCase() + "', 'MMC-Regular-DEFAULT', 'MMC-Medium', Arial, Helvetica, Verdana, sans-serif"
        };
      }
      return {};
    };
    var setLangHref = function setLangHref(language, languageSpecificPageSelection, queryString) {
      if (language.acronym && languageSpecificPageSelection && languageSpecificPageSelection.length > 0) {
        var filteredLang = languageSpecificPageSelection.filter(function (item) {
          return item.language === language.acronym;
        });
        if (filteredLang && filteredLang.length > 0) {
          return "" + filteredLang[0].languageSpecificPage + queryString;
        }
      }
      return "/" + language.acronym;
    };
    if (language && language.acronym) {
      var _clsx2;
      var languageName = language.fullName;
      if (typeof window !== 'undefined' && window && window.location) {
        try {
          var localeArr = language.code.split('_');
          var localeCountry = localeArr[0] === 'language-masters' ? 'GB' : localeArr[0].toUpperCase();
          var localeString = language.code ? localeArr[1] + "-" + localeCountry : language.acronym;
          var languageNameInLocale = new Intl.DisplayNames([localeString], {
            type: 'language'
          });
          languageName = languageNameInLocale.of(language.acronym);
        } catch (error) {
          console.log(error);
        }
      }
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: _navigationHeader["default"].languagesListItem,
        key: "lang_" + i
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _clsx9["default"])(_navigationHeader["default"].languageAnchorWrapper, (_clsx2 = {}, _clsx2[_navigationHeader["default"].isSelectedLanguage] = language.selected, _clsx2)),
        href: setLangHref(language, languageSpecificPageSelection, queryString),
        disabled: language.selected
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _navigationHeader["default"].languageAnchor
      }, language.acronym), /*#__PURE__*/_react["default"].createElement("span", {
        className: _navigationHeader["default"].languageName,
        style: setFont(language.acronym)
      }, languageName)));
    }
    return null;
  };
  NavigationHeaderV2.renderLanguages = function renderLanguages(languages, languageSpecificPageSelection, queryString, theme) {
    if (languages && languages.length > 1) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: _navigationHeader["default"].languagesListWrapper,
        role: "menuitem"
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: _navigationHeader["default"].languagesList
      }, languages.sort(function (x, y) {
        return y.selected - x.selected;
      }).map(function (language, i) {
        return NavigationHeaderV2.renderLanguageLink(language, languageSpecificPageSelection, queryString, i, theme);
      })));
    }
    return null;
  };
  NavigationHeaderV2.getFlyoutMenu = function getFlyoutMenu(data) {
    if (!data.flyoutMenu) return [];
    return isEmptyArray(data.flyoutMenu) ? [] : data.flyoutMenu;
  };
  NavigationHeaderV2.getQuickLinks = function getQuickLinks(flyoutMenu, data) {
    if (!(data.showQuickLinks === true && data.flyoutMenu)) return [];
    return flyoutMenu.map(function (menuItem) {
      return {
        label: menuItem.name,
        id: menuItem.id
      };
    });
  };
  NavigationHeaderV2.getKbaLinks = function getKbaLinks(data) {
    if (!data.kbaLinks) return [];
    return isEmptyArray(data.kbaLinks) ? [] : data.kbaLinks;
  };
  NavigationHeaderV2.getMobileQuickLinks = function getMobileQuickLinks(data) {
    return isEmptyArray(data.mobileQuickLinks) ? [] : data.mobileQuickLinks;
  };
  NavigationHeaderV2.getSectionLinks = function getSectionLinks(data) {
    if (!data.sectionLinks) return [];
    return isEmptyArray(data.sectionLink) ? [] : data.sectionLinks;
  };
  NavigationHeaderV2.getAnimation = function getAnimation(data) {
    return typeof data.animation !== 'undefined' ? data.animation : false;
  };
  NavigationHeaderV2.getSize = function getSize(flyoutMenu, kbaLinks) {
    return (flyoutMenu.length ? flyoutMenu.length : 0) + (kbaLinks.length ? kbaLinks.length : 0);
  };
  NavigationHeaderV2.renderBreadCrumb = function renderBreadCrumb(params) {
    var _clsx3;
    var links = params.links,
      animation = params.animation,
      isDarkTheme = params.isDarkTheme,
      breadcrumbShift = params.breadcrumbShift,
      theme = params.theme,
      showBreadCrumbs = params.showBreadCrumbs;
    return links.length > 0 && showBreadCrumbs && /*#__PURE__*/_react["default"].createElement("nav", {
      className: (0, _clsx9["default"])(_navigationHeader["default"].breadcrumbNav, (_clsx3 = {}, _clsx3[_navigationHeader["default"].breadcrumbIsDarkTheme] = isDarkTheme, _clsx3[_navigationHeader["default"].handleForTransparent] = animation, _clsx3[_navigationHeader["default"].breadcrumbNavShift] = breadcrumbShift, _clsx3))
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: _navigationHeader["default"].breadcrumbList
    }, links.map(function (link, idx) {
      return NavigationHeaderV2.renderBreadCrumbLink({
        link: link,
        idx: idx,
        linksLength: links.length,
        theme: theme
      });
    })));
  };
  function NavigationHeaderV2(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.langTooltipRestrictedMarkets = ['ca'];
    _this.onSearchKeyDown = function (e) {
      var isEnter = e.keyCode === 13;
      isEnter && _this.redirectToSearch();
    };
    _this.validateSearchTerm = function (term) {
      var MIN_3_CHAR_PATTERN = /^.{3,}$/;
      return MIN_3_CHAR_PATTERN.test(term);
    };
    var activeSectionUrl = null;
    var data = props.data,
      languageDirection = props.languageDirection;
    var sectionLinks = data.sectionLinks || [];
    var debounceDelay = 100;
    var debounceOptions = {
      leading: true,
      trailing: true
    };
    var solidBackground = NavigationHeaderV2.isSolidBackground(data.solidBackground, NavigationHeaderV2.childHasAsset(data.hasVideoAsset, data.hasImageAsset), sectionLinks);
    if (typeof sectionLinks === 'object' && typeof window !== 'undefined') {
      if (typeof window.location !== 'undefined') {
        var currentLoaction = window.location.href;
        sectionLinks.forEach(function (linkData) {
          var linkUrl = handleNestedProp(linkData, 'linkData.url');
          if (currentLoaction.includes(linkUrl)) {
            activeSectionUrl = linkUrl;
          }
        });
      }
    }
    _this.state = {
      activeNav: null,
      menuOpen: false,
      searchOpen: false,
      isHidden: false,
      activeSectionUrl: activeSectionUrl,
      hasScrolled: false,
      mobileNavActive: null,
      mobileSubNavActive: false,
      mobileSubNavData: null,
      solidBackground: solidBackground,
      spacerDOMRect: {
        x: 0,
        y: 0,
        width: 0,
        height: 115,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      atTop: true,
      topOffset: 0,
      languageTipDismissed: true,
      isSearchTermValid: false,
      isLocationTooltipOpen: false,
      queryString: ''
    };
    _this.refList = {};
    _this.headerRef = /*#__PURE__*/_react["default"].createRef();
    _this.keyHandler = _this.keyHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.focusHandler = _this.focusHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.moveUp = _this.moveUp.bind((0, _assertThisInitialized2["default"])(_this));
    _this.moveDown = _this.moveDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderHeaderSpacer = _this.renderHeaderSpacer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleScroll = _this.handleScroll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateHeaderSpacerHeight = _this.updateHeaderSpacerHeight.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleQuickLinkClick = _this.handleQuickLinkClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSubNavClose = _this.handleSubNavClose.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleWindowResize = (0, _debounce2["default"])(_this.handleWindowResize.bind((0, _assertThisInitialized2["default"])(_this)), debounceDelay, debounceOptions);
    _this.dismissLanguageTip = _this.dismissLanguageTip.bind((0, _assertThisInitialized2["default"])(_this));
    _this.checkIfRedirected = _this.checkIfRedirected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.widthNavItems = 120;
    _this.isRTL = languageDirection === 'rtl';
    _this.searchInputRef = /*#__PURE__*/_react["default"].createRef();
    _this.locationPromptRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  var _proto = NavigationHeaderV2.prototype;
  _proto.componentDidMount = /*#__PURE__*/function () {
    var _componentDidMount = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _this2 = this;
      var languagesList, topLevelItems, searchToggleIcon, locationToggleIcon, minBreakpoint;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.headerRef) {
                languagesList = this.headerRef.current.querySelector('[class*=_languagesList_]');
                topLevelItems = this.headerRef.current.querySelectorAll('.menu-panel-top-level-item');
                searchToggleIcon = this.headerRef.current.querySelector('[class*=_searchToggle_]');
                locationToggleIcon = this.headerRef.current.querySelector('[class*=_locationToggle_]');
                minBreakpoint = 1023;
                this.widthNavItems = minBreakpoint;
              }
              if (typeof window !== 'undefined') {
                window.addEventListener('onload', this.updateHeaderSpacerHeight);
                window.addEventListener('resize', this.handleWindowResize);
                window.addEventListener('scroll', this.handleScroll);
                if (!document.cookie.includes('languageTipDismissed=true')) {
                  this.setState(function () {
                    return {
                      languageTipDismissed: false
                    };
                  });
                }
                this.handleWindowResize();
                this.setState(function () {
                  return {
                    queryString: window.location.search
                  };
                });
              }
              this.updateHeaderSpacerHeight();
              _commonLibs.EventEmitter.subscribe('locationPromptAutoClose', function () {
                _this2.locationPromptDismissed();
              });
              _commonLibs.EventEmitter.subscribe('configuratorStepChanged', function (data) {
                _this2.setState(function () {
                  return {
                    queryString: window.location.search
                  };
                });
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    function componentDidMount() {
      return _componentDidMount.apply(this, arguments);
    }
    return componentDidMount;
  }();
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.updateHeaderSpacerHeight();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('onload', this.updateHeaderSpacerHeight);
      window.removeEventListener('resize', this.handleWindowResize);
      window.removeEventListener('scroll', this.handleScroll);
    }
    document.body.classList.remove("" + _navigationHeader["default"].preventScroll);
  };
  _proto.handleMenuToggleClick = function handleMenuToggleClick() {
    var menuOpen = this.state.menuOpen;
    if (menuOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
    if (window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'navclick',
        component: 'top_nav',
        action: 'mobile_hamburger',
        click_text: menuOpen ? 'close' : 'open'
      });
    }
  };
  _proto.handleSearchToggleClick = function handleSearchToggleClick() {
    var searchOpen = this.state.searchOpen;
    if (searchOpen) {
      this.closeSearch();
    } else {
      this.openSearch();
      this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          menuOpen: false
        });
      }); // Making sure menu closes when search panel is open
    }
  };
  _proto.handleLocationToggleClick = function handleLocationToggleClick() {
    var _this$locationPromptR, _this$locationPromptR2, _this$locationPromptR3, _this$locationPromptR4;
    var promptState = (_this$locationPromptR = this.locationPromptRef.current) == null ? void 0 : (_this$locationPromptR2 = _this$locationPromptR.wrappedInstance) == null ? void 0 : _this$locationPromptR2.promptState;
    var promptStates = (_this$locationPromptR3 = this.locationPromptRef.current) == null ? void 0 : (_this$locationPromptR4 = _this$locationPromptR3.wrappedInstance) == null ? void 0 : _this$locationPromptR4.promptStates;
    this.closeSearch(); // make sure search form closes before opening location prompt
    this.closeMenu(); // make sure menu closes before opening location prompt
    if (promptState === promptStates.open) {
      var _this$locationPromptR5, _this$locationPromptR6, _this$locationPromptR7;
      (_this$locationPromptR5 = this.locationPromptRef) == null ? void 0 : (_this$locationPromptR6 = _this$locationPromptR5.current) == null ? void 0 : (_this$locationPromptR7 = _this$locationPromptR6.wrappedInstance) == null ? void 0 : _this$locationPromptR7.closePrompt('dismissed');
    } else if (promptState === promptStates.dismissed) {
      var _this$locationPromptR8, _this$locationPromptR9, _this$locationPromptR0;
      (_this$locationPromptR8 = this.locationPromptRef) == null ? void 0 : (_this$locationPromptR9 = _this$locationPromptR8.current) == null ? void 0 : (_this$locationPromptR0 = _this$locationPromptR9.wrappedInstance) == null ? void 0 : _this$locationPromptR0.openPrompt('open');
    }
    this.setState(function () {
      return {
        isLocationTooltipOpen: false
      };
    });
  };
  _proto.handleNavSelect = function handleNavSelect(id, callback) {
    if (callback === void 0) {
      callback = null;
    }
    var _this$state = this.state,
      activeNav = _this$state.activeNav,
      menuOpen = _this$state.menuOpen,
      mobileNavActive = _this$state.mobileNavActive;
    var breakpoint = this.widthNavItems;
    var width = 0;
    if (typeof window !== 'undefined') {
      width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
    }
    if (activeNav === id && menuOpen) {
      if (width > breakpoint) {
        this.closeMenu(callback);
      } else {
        this.setActivateTab(null, callback);
      }
    } else {
      this.openMenu(id, callback);
      this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          searchOpen: false
        });
      }, callback); //making sure search panel closes if it is open
    }
  };
  _proto.handleSubNavSelect = function handleSubNavSelect(id, callback, index, labelName) {
    if (callback === void 0) {
      callback = null;
    }
    var _this$state2 = this.state,
      activeNav = _this$state2.activeNav,
      menuOpen = _this$state2.menuOpen,
      mobileNavActive = _this$state2.mobileNavActive;
    if (mobileNavActive) {
      this.setState({
        mobileSubNavData: index,
        mobileSubNavActive: true
      });
    }
    var breakpoint = this.widthNavItems;
    var width = 0;
    if (typeof window !== 'undefined') {
      width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
    }
    if (activeNav === id && menuOpen) {
      if (width > breakpoint) {
        this.closeMenu(callback);
      } else {
        this.setActivateTab(null, callback);
      }
    } else {
      this.openMenu(id, callback);
      this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          searchOpen: false
        });
      }, callback); //making sure search panel closes if it is open
    }
    if (window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'navclick',
        component: 'top_nav',
        action: 'nav_click',
        click_text: labelName
      });
    }
  };
  _proto.handleSubNavClose = function handleSubNavClose() {
    this.setState({
      mobileSubNavActive: false
    });
  };
  _proto.handleWindowResize = function handleWindowResize() {
    var _this$state3 = this.state,
      activeNav = _this$state3.activeNav,
      menuOpen = _this$state3.menuOpen,
      mobileNavActive = _this$state3.mobileNavActive;
    this.updateHeaderSpacerHeight();
    var breakpoint = this.widthNavItems;
    var width = 0;
    if (typeof window !== 'undefined') {
      width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
      if (width >= breakpoint) {
        if (activeNav === null && menuOpen === true) {
          this.setState(function () {
            return {
              menuOpen: false,
              mobileNavActive: false,
              mobileSubNavActive: false
            };
          });
        } else if (mobileNavActive !== false) {
          this.setState(function () {
            return {
              mobileNavActive: false,
              mobileSubNavActive: false
            };
          });
        }
      } else if (width < breakpoint && mobileNavActive !== true) {
        this.setState(function () {
          return {
            mobileNavActive: true
          };
        });
      }
    }
  };
  _proto.handleQuickLinkClick = function handleQuickLinkClick(e) {
    this.openMenu(e.target.getAttribute('data-target-panel').toLowerCase());
  };
  _proto.handleScroll = function handleScroll() {
    var state = this.state;
    var atTop = state.atTop;
    var navHeight = state.spacerDOMRect.height;
    var scrollPosition = NavigationHeaderV2.getScrollPosition();
    var scrollDirection = NavigationHeaderV2.getScrollDirection(scrollPosition);
    var currentlyAtTop = scrollPosition < navHeight;
    previousScrollY = scrollPosition;
    if (scrollDirection === 'up' && state.isHidden) {
      this.scrollUpAndHidden();
    } else if (scrollDirection === 'down' && !state.isHidden && !currentlyAtTop) {
      this.scrollDownNotHiddenNotAtTop(currentlyAtTop);
    } else if (currentlyAtTop !== atTop) {
      this.setState(function () {
        return {
          atTop: currentlyAtTop
        };
      });
    } else if (atTop && scrollDirection === 'down') {
      this.setState(function () {
        return {
          topOffset: scrollPosition
        };
      });
    } else if (atTop && scrollDirection === 'up') {
      this.setState(function () {
        return {
          topOffset: 0
        };
      });
    }
  };
  _proto.getElementHeightWidth = function getElementHeightWidth(elem) {
    return new Promise(function (resolve) {
      // new `IntersectionObserver` constructor
      var observer = new IntersectionObserver(function (entries) {
        // Loop through all `entries` returned by the observer
        // The `entry.boundingClientRect` is where all the dimensions are stored
        var bounds = entries[0].boundingClientRect;
        // Disconnect the observer to stop from running in the background
        observer.disconnect();
        resolve(bounds);
      });
      // Run the `observe` function of the `IntersectionObserver` on the element
      observer.observe(elem);
    });
  };
  _proto.setActivateTab = function setActivateTab(id, callback) {
    if (id === void 0) {
      id = null;
    }
    if (callback === void 0) {
      callback = null;
    }
    this.setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        activeNav: id
      });
    }, callback);
  };
  _proto.dismissLanguageTip = function dismissLanguageTip() {
    var languageTipDismissed = this.state.languageTipDismissed;
    if (!languageTipDismissed) {
      if (typeof window !== 'undefined') {
        document.cookie = 'languageTipDismissed=true';
      }
      this.setState(function () {
        return {
          languageTipDismissed: true
        };
      });
    }
  };
  _proto.scrollUpAndHidden = function scrollUpAndHidden() {
    var hasScrolled = this.state.hasScrolled;
    if (hasScrolled === false) {
      this.setState(function () {
        return {
          isHidden: false,
          hasScrolled: true
        };
      });
    } else {
      this.setState(function () {
        return {
          isHidden: false
        };
      });
    }
  };
  _proto.scrollDownNotHiddenNotAtTop = function scrollDownNotHiddenNotAtTop(currentlyAtTop) {
    var hasScrolled = this.state.hasScrolled;
    if (hasScrolled === false) {
      this.setState(function () {
        return {
          isHidden: true,
          hasScrolled: true,
          atTop: currentlyAtTop,
          topOffset: 0
        };
      });
    } else {
      this.setState(function () {
        return {
          isHidden: true,
          atTop: currentlyAtTop,
          topOffset: 0
        };
      });
    }
  };
  _proto.focusHandler = function focusHandler(setTop) {
    if (setTop === true) {
      this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          isHidden: false,
          atTop: true
        });
      });
    } else {
      this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          isHidden: false
        });
      });
    }
  };
  _proto.keyHandler = function keyHandler(e, i, ref) {
    var domEl =
    // eslint-disable-next-line react/no-find-dom-node
    ref instanceof _react["default"].Component ? _reactDom["default"].findDOMNode(ref) : ref;
    var keyCodes = {
      esc: 27,
      left: 37,
      right: 39,
      down: 40,
      up: 38
    };
    switch (e.which) {
      case keyCodes.left:
        NavigationHeaderV2.moveLeft(domEl);
        break;
      case keyCodes.right:
        NavigationHeaderV2.moveRight(domEl);
        break;
      case keyCodes.down:
        this.moveDown(domEl, ref);
        break;
      case keyCodes.up:
        this.moveUp(domEl);
        break;
      case keyCodes.esc:
        this.closeMenu();
        document.activeElement.blur();
        break;
      default:
        break;
    }
  };
  _proto.moveDown = function moveDown(domEl, ref) {
    // is there anywhere to go to?
    var _NavigationHeaderV2$g = NavigationHeaderV2.getAriaData(domEl),
      haspopup = _NavigationHeaderV2$g.haspopup;
    if (!haspopup) return;
    this.handleNavSelect(ref.props.name.toLowerCase(), function () {
      domEl.querySelector('.menu-panel-sub-list-item[aria-posinset="1"] a').focus();
    });
  };
  _proto.moveUp = function moveUp(domEl) {
    // is there anywhere to go to?
    var _NavigationHeaderV2$g2 = NavigationHeaderV2.getAriaData(domEl),
      haspopup = _NavigationHeaderV2$g2.haspopup;
    if (haspopup) return;
    var domSelector = "[data-menu-item-name=\"" + domEl.dataset.menuItemParentName + "\"] button";
    var domTarget = document.querySelector(domSelector);
    if (domTarget instanceof Element) {
      domTarget.focus();
      this.closeMenu();
    }
  };
  _proto.updateHeaderSpacerHeight = function updateHeaderSpacerHeight() {
    var _this3 = this;
    NavigationHeaderV2.getHeaderSpacerHeight(this.headerRef).then(function (spacerDOMRect) {
      var height = _this3.state.spacerDOMRect.height;
      if (height !== spacerDOMRect.height) {
        _this3.setState(function () {
          return {
            spacerDOMRect: spacerDOMRect
          };
        });
      }
    });
  };
  _proto.checkForDismiss = function checkForDismiss(e) {
    var clickedEl = e.target;
    if (e.target.closest('nav') === null && clickedEl.className.indexOf('menuToggle') === -1) {
      this.closeMenu();
    }
  };
  _proto.openMenu = function openMenu(id, callback) {
    if (callback === void 0) {
      callback = null;
    }
    var mobileNavActive = this.state.mobileNavActive;
    var breakpoint = this.widthNavItems;
    document.body.classList.add("" + _navigationHeader["default"].preventScroll);
    if (typeof window !== 'undefined' && window.innerWidth < breakpoint) {
      document.body.classList.add("" + _navigationHeader["default"].fixedBody);
    }
    if (id) {
      this.setState(function () {
        return {
          menuOpen: true,
          activeNav: id
        };
      }, callback);
    } else {
      this.setState(function () {
        return {
          menuOpen: true
        };
      }, callback);
    }
    if (mobileNavActive) {
      var _this$locationPromptR1, _this$locationPromptR10, _this$locationPromptR11;
      (_this$locationPromptR1 = this.locationPromptRef) == null ? void 0 : (_this$locationPromptR10 = _this$locationPromptR1.current) == null ? void 0 : (_this$locationPromptR11 = _this$locationPromptR10.wrappedInstance) == null ? void 0 : _this$locationPromptR11.closePrompt('dismissed', 0);
    }
  };
  _proto.closeMenu = function closeMenu(callback) {
    if (callback === void 0) {
      callback = null;
    }
    var breakpoint = this.widthNavItems;
    document.body.classList.remove("" + _navigationHeader["default"].preventScroll);
    if (typeof window !== 'undefined' && window.innerWidth < breakpoint) {
      document.body.classList.remove("" + _navigationHeader["default"].fixedBody);
      // window.scrollTo(0, this.state.mobilePageOffset);
    }
    this.setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        menuOpen: false
      });
    }, callback);
  };
  _proto.openSearch = function openSearch(id, callback) {
    var _this$locationPromptR12, _this$locationPromptR13, _this$locationPromptR14;
    if (callback === void 0) {
      callback = null;
    }
    var mobileNavActive = this.state.mobileNavActive;
    var breakpoint = this.widthNavItems;
    document.body.classList.add("" + _navigationHeader["default"].preventScroll);
    if (typeof window !== 'undefined' && window.innerWidth < breakpoint) {
      document.body.classList.add("" + _navigationHeader["default"].fixedBody);
    }
    if (id) {
      this.setState(function () {
        return {
          searchOpen: true,
          activeNav: id
        };
      }, callback);
    } else {
      this.setState(function () {
        return {
          searchOpen: true
        };
      }, callback);
    }
    this.searchInputRef.current.focus();
    (_this$locationPromptR12 = this.locationPromptRef) == null ? void 0 : (_this$locationPromptR13 = _this$locationPromptR12.current) == null ? void 0 : (_this$locationPromptR14 = _this$locationPromptR13.wrappedInstance) == null ? void 0 : _this$locationPromptR14.closePrompt('dismissed', 0);
  };
  _proto.closeSearch = function closeSearch(callback) {
    if (callback === void 0) {
      callback = null;
    }
    var breakpoint = this.widthNavItems;
    document.body.classList.remove("" + _navigationHeader["default"].preventScroll);
    if (typeof window !== 'undefined' && window.innerWidth < breakpoint) {
      document.body.classList.remove("" + _navigationHeader["default"].fixedBody);
      // window.scrollTo(0, this.state.mobilePageOffset);
    }
    this.setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        searchOpen: false
      });
    }, callback);
  };
  _proto.checkIfRedirected = function checkIfRedirected() {
    var query = this.props.location.query;
    var queryParams = query || {};
    return !!('rd' in queryParams && queryParams.rd === 'true');
  };
  _proto.renderHeaderSpacer = function renderHeaderSpacer(solidBackground, mobileNavActive, isMenuOpen) {
    var _clsx4;
    if (solidBackground === void 0) {
      solidBackground = false;
    }
    if (solidBackground === false) {
      return '';
    }
    var height = this.state.spacerDOMRect.height;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx9["default"])(_navigationHeader["default"].navHeaderSpacer, (_clsx4 = {}, _clsx4[_navigationHeader["default"].isMobileNav] = mobileNavActive === true, _clsx4[_navigationHeader["default"].isMenuOpen] = isMenuOpen === true, _clsx4)),
      style: {
        height: height
      }
    });
  };
  _proto.renderQuickLink = function renderQuickLink(linkData, i, theme) {
    var _this4 = this;
    var checkedLink = {
      id: handleNestedProp(linkData, 'linkData.id'),
      label: handleNestedProp(linkData, 'linkData.label')
    };
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: checkedLink.id,
      className: (0, _clsx9["default"])(_navigationHeader["default"].navQuickLink, 'menu-panel-sub-list-item')
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      onFocus: function onFocus() {
        return _this4.focusHandler(true);
      },
      "data-target-panel": checkedLink.id,
      className: (0, _clsx9["default"])(theme.labelSmall, _navigationHeader["default"].bottomLinks),
      onClick: this.handleQuickLinkClick
    }, checkedLink.label));
  };
  _proto.mobileQuickLinkClickHandler = function mobileQuickLinkClickHandler(linkLabel) {
    var market = this.props.market;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'menu_click',
        comp_page: {
          position: 'top menu',
          main_category: null,
          selected_category: linkLabel ? linkLabel.toLowerCase() : null
        }
      });
    }
  };
  _proto.renderAdditionalLink = function renderAdditionalLink(linkData, i, theme, iconMap) {
    var _this5 = this;
    var checkedLink = {
      url: handleNestedProp(linkData, 'linkData.url'),
      label: handleNestedProp(linkData, 'linkData.label')
    };
    var matchedIcon = null;
    if (iconMap) {
      matchedIcon = iconMap.find(function (icon) {
        return icon.url === checkedLink.url || icon.url.includes(checkedLink.url);
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_linkItem["default"], {
      key: checkedLink.url,
      url: checkedLink.url,
      classes: ['navAdditionalLink'],
      anchorClasses: [matchedIcon ? theme["mmcIcon" + matchedIcon.icon] : ''],
      keyHandler: function keyHandler(e) {
        return _this5.keyHandler(e, i);
      },
      clickHandler: function clickHandler() {
        return _this5.mobileQuickLinkClickHandler(checkedLink.label);
      },
      focusHandler: this.focusHandler,
      theme: theme
    }, checkedLink.label);
  };
  _proto.renderLinkSubNavBtn = function renderLinkSubNavBtn(linkData, i, setSize, currentSetSize) {
    var _this6 = this;
    if (linkData === null || linkData.name === null) {
      return false;
    }
    var checkedLink = {
      name: handleNestedProp(linkData, 'linkData.name'),
      noDropDown: handleNestedProp(linkData, 'linkData.noDropDown'),
      hideArrows: handleNestedProp(linkData, 'linkData.hideArrows'),
      products: handleNestedProp(linkData, 'linkData.productsNextGen'),
      vehicleCardsCTAs: handleNestedProp(linkData, 'linkData.vehicleCardsCTAs'),
      links: handleNestedProp(linkData, 'linkData.links'),
      backgroundImage: handleNestedProp(linkData, 'linkData.backgroundImage'),
      imageWithText: handleNestedProp(linkData, 'linkData.imageWithText'),
      addPriceDisclaimer: handleNestedProp(linkData, 'linkData.addPriceDisclaimer'),
      priceDisclaimerId: handleNestedProp(linkData, 'linkData.priceDisclaimerId'),
      disclaimerData: handleNestedProp(linkData, 'linkData.disclaimerDataForNav'),
      subNavigationcontainer: handleNestedProp(linkData, 'linkData.subNavigationcontainer'),
      shoppingToolsCTAs: handleNestedProp(linkData, 'linkData.shoppingToolsCTAs')
    };
    var _this$state4 = this.state,
      activeNav = _this$state4.activeNav,
      menuOpen = _this$state4.menuOpen,
      mobileNavActive = _this$state4.mobileNavActive;
    var _this$props = this.props,
      theme = _this$props.theme,
      currentPath = _this$props.currentPath,
      market = _this$props.market;
    var id = checkedLink.name.toLowerCase();
    this.refList[id] = this.refList[id] || {};
    return /*#__PURE__*/_react["default"].createElement(_menuPanelRenderer.MenuPanelRenderer, {
      key: id,
      index: i,
      name: checkedLink.name,
      noDropDown: checkedLink.noDropDown,
      hideArrows: checkedLink.hideArrows,
      bacxkgroundImage: checkedLink.backgroundImage,
      links: checkedLink.links,
      vehicleCardsCTAs: checkedLink.vehicleCardsCTAs,
      products: checkedLink.products,
      addPriceDisclaimer: checkedLink.addPriceDisclaimer,
      subNavigationcontainer: checkedLink.subNavigationcontainer,
      shoppingToolsCTAs: checkedLink.shoppingToolsCTAs,
      priceDisclaimerId: linkData.priceDisclaimerId,
      disclaimerData: linkData.disclaimerDataForNav,
      displayNavInTwoCxolumns: linkData.displayNavInTwoColumns,
      imageWithText: linkData.imageWithText,
      theme: theme,
      activeNav: activeNav,
      menuOpen: menuOpen,
      clickHandler: function clickHandler() {
        return _this6.handleSubNavSelect(id, null, i, checkedLink.name);
      },
      focusHandler: this.focusHandler,
      keyHandler: function keyHandler(e) {
        _this6.keyHandler(e, i, _this6.refList[id][i]);
      },
      keyHandlerMethod: this.keyHandler,
      ref: function ref(el) {
        _this6.refList[id][i] = el;
        return el;
      },
      setSize: setSize,
      posInSet: i + 1,
      isLast: i + 1 === currentSetSize,
      currentPath: currentPath,
      market: market,
      mobileNavActive: mobileNavActive
    });
  };
  _proto.renderMenuPanelOffCanvas = function renderMenuPanelOffCanvas(linkData, index) {
    var _this7 = this;
    var _this$state5 = this.state,
      mobileSubNavData = _this$state5.mobileSubNavData,
      mobileNavActive = _this$state5.mobileNavActive;
    var isSelected = index === mobileSubNavData ? true : false;
    if (linkData === null || linkData.name === null) {
      return false;
    }
    var checkedLink = {
      name: handleNestedProp(linkData, 'linkData.name'),
      products: handleNestedProp(linkData, 'linkData.productsNextGen'),
      hideArrows: handleNestedProp(linkData, 'linkData.hideArrows'),
      links: handleNestedProp(linkData, 'linkData.links'),
      backgroundImage: handleNestedProp(linkData, 'linkData.backgroundImage'),
      imageWithText: handleNestedProp(linkData, 'linkData.imageWithText'),
      addPriceDisclaimer: handleNestedProp(linkData, 'linkData.addPriceDisclaimer'),
      priceDisclaimerId: handleNestedProp(linkData, 'linkData.priceDisclaimerId'),
      disclaimerData: handleNestedProp(linkData, 'linkData.disclaimerDataForNav'),
      subNavigationcontainer: handleNestedProp(linkData, 'linkData.subNavigationcontainer'),
      shoppingToolsCTAs: handleNestedProp(linkData, 'linkData.shoppingToolsCTAs')
    };
    var _this$state6 = this.state,
      activeNav = _this$state6.activeNav,
      menuOpen = _this$state6.menuOpen;
    var _this$props2 = this.props,
      theme = _this$props2.theme,
      currentPath = _this$props2.currentPath,
      market = _this$props2.market;
    var id = checkedLink.name.toLowerCase();
    return /*#__PURE__*/_react["default"].createElement(_menuPanelMobileOffCanvas["default"], {
      name: checkedLink.name,
      backgroundImage: checkedLink.backgroundImage,
      links: checkedLink.links,
      products: checkedLink.products,
      hideArrows: checkedLink.hideArrows,
      addPriceDisclaimer: checkedLink.addPriceDisclaimer,
      subNavigationcontainer: checkedLink.subNavigationcontainer,
      priceDisclaimerId: linkData.priceDisclaimerId,
      disclaimerData: linkData.disclaimerDataForNav,
      displayNavInTwoColumns: linkData.displayNavInTwoColumns,
      theme: theme,
      imageWithText: checkedLink.imageWithText,
      activeNav: activeNav,
      menuOpen: menuOpen,
      clickHandler: function clickHandler() {
        return _this7.handleSubNavClose();
      },
      focusHandler: this.focusHandler,
      keyHandlerMethod: this.keyHandler,
      currentPath: currentPath,
      market: market,
      isSelected: isSelected,
      mobileNavActive: mobileNavActive,
      shoppingToolsCTAs: checkedLink.shoppingToolsCTAs
    });
  };
  _proto.renderQuickLinks = function renderQuickLinks(quickLinks, theme) {
    var _this8 = this;
    return quickLinks.length > 0 && /*#__PURE__*/_react["default"].createElement("nav", {
      className: (0, _clsx9["default"])(_navigationHeader["default"].navQuickLinksInner, _navigationHeader["default"].hideDesktop)
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: _navigationHeader["default"].navQuickLinkList
    }, quickLinks.map(function (link, i) {
      return _this8.renderQuickLink(link, i, theme);
    })));
  };
  _proto.renderLangTooltip = function renderLangTooltip(params) {
    var languages = params.languages,
      languageTipDismissed = params.languageTipDismissed,
      hasScrolled = params.hasScrolled,
      menuOpen = params.menuOpen,
      searchOpen = params.searchOpen,
      theme = params.theme,
      mobileNavActive = params.mobileNavActive;
    return languages.length > 1 && !languageTipDismissed && !hasScrolled && !menuOpen && !searchOpen && this.checkIfRedirected() && /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
      toolTipMessage: NavigationHeaderV2.getToolTipMessage(languages),
      toolTipLanguage: NavigationHeaderV2.getToolTipLanguage(languages),
      theme: theme,
      setCookie: this.dismissLanguageTip,
      mobileNavActive: mobileNavActive
    });
  };
  _proto.renderMobileQuickLinks = function renderMobileQuickLinks(mobileQuickLinks, theme, iconMap) {
    var _this9 = this;
    return mobileQuickLinks && mobileQuickLinks.map(function (link, i) {
      return _this9.renderAdditionalLink(link, i, theme, iconMap);
    });
  };
  _proto.renderFlyoutMenu = function renderFlyoutMenu(flyoutMenu, setSize, theme, navigationType) {
    var _this0 = this;
    var market = this.props.market;

    // if (navigationType === 'subnavigationType') {
    //   return (
    //     flyoutMenu &&
    //     flyoutMenu.map((link, i) =>
    //       this.renderLinkSubNavBtn(
    //         link,
    //         i,
    //         setSize,
    //         flyoutMenu.length,
    //         theme,
    //         navigationType,
    //       ),
    //     )
    //   );
    // }

    return flyoutMenu && flyoutMenu.map(function (link, i) {
      return _this0.renderLinkSubNavBtn(link, i, setSize, flyoutMenu.length, theme, navigationType);
    });
  };
  _proto.redirectToSearch = function redirectToSearch() {
    var _this$props3 = this.props,
      router = _this$props3.router,
      data = _this$props3.data;
    var searchNavigationPath = data.searchNavigationPath;
    var query = this.searchInputRef.current.value;
    var isValid = this.validateSearchTerm(query);
    if (!isValid) {
      this.setState(function () {
        return {
          isSearchTermValid: false
        };
      });
    } else {
      this.setState(function () {
        return {
          isSearchTermValid: true
        };
      });
      var searchUrl = new URL("" + window.origin + searchNavigationPath);
      searchUrl.searchParams.set('q', query);
      window.location = searchUrl;
    }
  };
  _proto.locationPromptDismissed = function locationPromptDismissed() {
    this.setState(function () {
      return {
        isLocationTooltipOpen: true
      };
    });
  };
  _proto.render = function render() {
    var _clsx5,
      _this1 = this,
      _clsx6,
      _clsx7,
      _clsx8;
    var _this$props4 = this.props,
      data = _this$props4.data,
      theme = _this$props4.theme,
      market = _this$props4.market;
    var displaySearchfield = data.displaySearchfield,
      searchLabel = data.searchLabel,
      searchPlaceholder = data.searchPlaceholder,
      searchInputWarningMessage = data.searchInputWarningMessage,
      enableLocationPrompt = data.enableLocationPrompt,
      locationPrompt = data.locationPrompt,
      navigationType = data.navigationType,
      languageSpecificPageSelection = data.languageSpecificPageSelection,
      secondaryNavHeading = data.secondaryNavHeading;
    var mobileQuickLinks = NavigationHeaderV2.getMobileQuickLinks(data);
    var flyoutMenu = NavigationHeaderV2.getFlyoutMenu(data);
    var quickLinks = NavigationHeaderV2.getQuickLinks(flyoutMenu, data);
    var kbaLinks = NavigationHeaderV2.getKbaLinks(data);
    var sectionLinks = NavigationHeaderV2.getSectionLinks(data);
    var languages = data.languages || [];
    var animation = NavigationHeaderV2.getAnimation(data);
    var _this$state7 = this.state,
      menuOpen = _this$state7.menuOpen,
      searchOpen = _this$state7.searchOpen,
      isHidden = _this$state7.isHidden,
      hasScrolled = _this$state7.hasScrolled,
      topOffset = _this$state7.topOffset,
      solidBackground = _this$state7.solidBackground,
      languageTipDismissed = _this$state7.languageTipDismissed,
      mobileNavActive = _this$state7.mobileNavActive,
      isSearchTermValid = _this$state7.isSearchTermValid,
      isLocationTooltipOpen = _this$state7.isLocationTooltipOpen,
      mobileSubNavActive = _this$state7.mobileSubNavActive,
      mobileSubNavData = _this$state7.mobileSubNavData,
      queryString = _this$state7.queryString;
    var setSize = NavigationHeaderV2.getSize(flyoutMenu, kbaLinks);
    var headerStyle = topOffset > 0 ? {
      transform: "translateY(-" + topOffset + "px)",
      transition: 'none'
    } : {};
    var cachedLocation = (0, _commonSetLocation.getCachedLocation)();
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].mobileContentCover + " " + (menuOpen === true ? _navigationHeader["default"].openMenu : '')
    }), /*#__PURE__*/_react["default"].createElement("header", {
      className: (0, _clsx9["default"])(_navigationHeader["default"].navHeader, _navigationHeader["default"].solidBackground, (_clsx5 = {}, _clsx5[_navigationHeader["default"].animate] = animation === true, _clsx5[_navigationHeader["default"].isActive] = menuOpen === true, _clsx5[_navigationHeader["default"].isSearching] = searchOpen === true, _clsx5[_navigationHeader["default"].isHidden] = isHidden === true && menuOpen === false, _clsx5[_navigationHeader["default"].hasScrolled] = hasScrolled === false, _clsx5[_navigationHeader["default"].isMobileNav] = mobileNavActive === true, _clsx5)),
      style: headerStyle,
      tabIndex: isHidden === true && menuOpen === false ? '-1' : '',
      ref: this.headerRef,
      onClick: function onClick(e) {
        return _this1.checkForDismiss(e);
      },
      "data-links": !isEmptyArray(sectionLinks),
      "data-solidbackground": solidBackground
    }, enableLocationPrompt && /*#__PURE__*/_react["default"].createElement(_locationPrompt.LocationPrompt, {
      theme: theme,
      data: {
        locationPrompt: locationPrompt
      },
      ref: this.locationPromptRef
    }), /*#__PURE__*/_react["default"].createElement("nav", {
      className: (0, _clsx9["default"])(_navigationHeader["default"].navInner, (_clsx6 = {}, _clsx6[theme.dark] = menuOpen === false, _clsx6))
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: _navigationHeader["default"].logoLink,
      onFocus: function onFocus() {
        return _this1.focusHandler(true);
      },
      href: handleNestedProp(data, 'data.logo.link.url')
    }, /*#__PURE__*/_react["default"].createElement("img", {
      fetchpriority: "high",
      width: 76,
      height: 74,
      className: _navigationHeader["default"].navLogo,
      src: handleNestedProp(data, 'data.logo.whiteImage.image'),
      alt: handleNestedProp(data, 'data.logo.altText')
    }), /*#__PURE__*/_react["default"].createElement("img", {
      fetchpriority: "high",
      width: 76,
      height: 74,
      className: (0, _clsx9["default"])(_navigationHeader["default"].navLogo, _navigationHeader["default"].logoExpanded),
      src: handleNestedProp(data, 'data.logo.blackImage.image'),
      alt: handleNestedProp(data, 'data.logo.altText')
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].rightMenuDock
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _clsx9["default"])(_navigationHeader["default"].navBtn, _navigationHeader["default"].menuToggle, _navigationHeader["default"].hideDesktop),
      onClick: function onClick() {
        return _this1.handleMenuToggleClick();
      },
      type: "button"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _navigationHeader["default"].elementInvisible
    }, menuOpen === false ? handleNestedProp(data, 'data.menuModule.open') : handleNestedProp(data, 'data.menuModule.closed')))), /*#__PURE__*/_react["default"].createElement("ul", {
      role: "menu",
      className: (0, _clsx9["default"])(_navigationHeader["default"].navBtnList, (_clsx7 = {}, _clsx7[_navigationHeader["default"].isOffCanvas] = mobileSubNavActive === true, _clsx7))
    }, this.renderFlyoutMenu(flyoutMenu, setSize, theme, navigationType)), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx9["default"])(_navigationHeader["default"].mobileSubPageNav, (_clsx8 = {}, _clsx8[_navigationHeader["default"].isActive] = menuOpen === true && mobileSubNavActive === true, _clsx8))
    }, flyoutMenu && flyoutMenu.map(function (link, i) {
      return _this1.renderMenuPanelOffCanvas(link, i);
    }))), NavigationHeaderV2.renderSectionLinks({
      sectionLinks: sectionLinks,
      theme: theme,
      enableSubNavVLP: data.enableSubNavVLP,
      overrideParentPageLabelText: data.overrideParentPageLabelText,
      secondaryNavHeading: secondaryNavHeading
    }), /*#__PURE__*/_react["default"].createElement(_commonTooltip["default"], {
      isOpen: isLocationTooltipOpen,
      timeout: 10000,
      delay: 3000,
      toolTipMessage: locationPrompt == null ? void 0 : locationPrompt.locationIgnoredMessage
    })), this.renderHeaderSpacer(true, mobileNavActive, menuOpen), data.quickLinks !== null && /*#__PURE__*/_react["default"].createElement(_structuredData.StructuredData, {
      schemaType: "BreadcrumbList",
      data: market ? data.quickLinks : data.quickLinks.slice(1)
    }), data.quickLinks !== null && NavigationHeaderV2.renderBreadCrumb({
      links: market ? data.quickLinks : data.quickLinks.slice(1),
      animation: data.animation,
      isDarkTheme: data.isDarkTheme,
      hasImageAsset: data.hasImageAsset,
      hasVideoAsset: data.hasVideoAsset,
      breadcrumbShift: data.breadcrumbShift,
      showBreadCrumbs: data.showBreadCrumbs,
      theme: theme
    }), !this.langTooltipRestrictedMarkets.includes(market) && this.renderLangTooltip({
      languages: languages,
      languageTipDismissed: languageTipDismissed,
      hasScrolled: hasScrolled,
      menuOpen: menuOpen,
      searchOpen: searchOpen,
      theme: theme,
      mobileNavActive: mobileNavActive
    }));
  };
  return NavigationHeaderV2;
}(_react.Component);
NavigationHeaderV2.displayName = 'NavigationHeaderV2';
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market
  };
};
var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(NavigationHeaderV2));
exports["default"] = _default;